(function () {
  function init(root) {
    var tabs = root.querySelectorAll('.custom-tab');
    var tabContents = root.querySelectorAll('.custom__tab-content');
    if (!tabs.length || !tabContents.length) return;

    function convertTablesToParagraphs(container) {
      var tables = container.querySelectorAll('table');
      tables.forEach(function (table) {
        var rows = Array.from(table.querySelectorAll('tr'));
        if (rows.length === 0) return;

        var wrapper = document.createElement('div');
        wrapper.className = 'custom-tab-paragraphs';

        rows.forEach(function (row) {
          var cells = Array.from(row.querySelectorAll('td, th'));
          if (cells.length === 0) return;

          var cellTexts = cells.map(function (c) { return c.textContent.trim().toLowerCase(); });

          // Skip header row if it contains generic labels like specs/details
          if (cells.length === 2 && 
              (cellTexts[0] === 'specs' || cellTexts[0] === 'spec' || cellTexts[0] === 'key' || cellTexts[0] === 'feature') &&
              (cellTexts[1] === 'details' || cellTexts[1] === 'detail' || cellTexts[1] === 'value' || cellTexts[1] === 'description')) {
            return;
          }
          if (cells.length === 1 && (cellTexts[0] === 'specs' || cellTexts[0] === 'details')) {
            return;
          }

          var p = document.createElement('p');
          p.className = 'tab-paragraph';

          if (cells.length >= 2) {
            var keyHTML = cells[0].innerHTML.trim();
            keyHTML = keyHTML.replace(/:\s*$/, '');
            var valHTML = cells.slice(1).map(function (c) { return c.innerHTML.trim(); }).join(' - ');

            if (keyHTML && valHTML) {
              p.innerHTML = '<strong>' + keyHTML + ':</strong> ' + valHTML;
            } else if (valHTML) {
              p.innerHTML = valHTML;
            } else if (keyHTML) {
              p.innerHTML = keyHTML;
            }
          } else if (cells.length === 1) {
            p.innerHTML = cells[0].innerHTML.trim();
          }

          if (p.innerHTML.trim().length > 0) {
            wrapper.appendChild(p);
          }
        });

        if (wrapper.children.length > 0) {
          var parent = table.parentNode;
          parent.replaceChild(wrapper, table);
          if (parent && !parent.classList.contains('custom__tab-content')) {
            parent.removeAttribute('style');
            parent.style.border = 'none';
            parent.style.outline = 'none';
            parent.style.boxShadow = 'none';
            parent.style.borderRadius = '0';
          }
        }
      });
    }

    tabContents.forEach(function (content) {
      convertTablesToParagraphs(content);
    });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var contentId = this.dataset.contentId;
        var content = contentId ? document.getElementById(contentId) : null;

        tabContents.forEach(function (c) {
          c.classList.remove('active');
        });
        tabs.forEach(function (t) {
          t.classList.remove('active');
        });

        this.classList.add('active');
        if (content) {
          content.classList.add('active');
          convertTablesToParagraphs(content);
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-custom-tabs]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

